// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * L'etoile SIMPLE, en contour : le bouton qui OUVRE le tiroir des favoris
 * (rangee 3b). Ce n'est PAS la moitie vide d'une bascule, et il n'existe pas
 * d'etoile pleine dans ce set : l'etat « favori actif » est rendu par un aplat
 * d'encre sur la pastille du tiroir, pas par un second glyphe. L'etoile qui
 * FABRIQUE un favori est `IconFavAddBigBig`, elle porte un PLUS.
 * Source `fav.svg`.
 */
export const IconFav = createCustomIcon(
  'IconFav',
  '0 0 236.84 235.99',
  <path
    fill="currentColor"
    d="M118.58,198.41l-83.6,37.58,17.58-88.37L0,94.95l76.87-23.83L118.43,0l41.61,71.17,76.8,23.79-52.55,52.65,17.43,88.28-83.13-37.49ZM118.55,171.01l49.19,22.12-10.62-53.77,32.57-32.79-46.4-14.48-24.86-42.42-25.07,42.58-46.23,14.31,32.59,32.78-10.51,53.74,49.34-22.08Z"
  />,
);
